module.exports = __webpack_public_path__ + "img/center back length from waist to hem.b2e9f1d7.png";